<template>
  <section class="second">
    <div class="container">
      <div class="wrap">
        <h3>スキル</h3>
      </div>
      <div class="skills">
        <div
          data-aos="fade-left"
          data-aos-duration="1500"
          class="skill"
          :class="skill.name"
          v-for="(skill, index) in skills"
          :key="index"
        >
          <img :src="skill.icon" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SkillComponentJa",
  data() {
    return {
      skills: [
        {
          name: "html",
          icon: require("../assets/icon/html.png"),
        },
        { name: "css", icon: require("../assets/icon/css.png") },
        {
          name: "javascript",

          icon: require("../assets/icon/javascript.png"),
        },
        {
          name: "java",

          icon: require("../assets/icon/java.png"),
        },
        {
          name: "wordpress",

          icon: require("../assets/icon/wordpress.png"),
        },
        {
          name: "sass",

          icon: require("../assets/icon/sass.png"),
        },
        {
          name: "bootstrap",

          icon: require("../assets/icon/bootstrap.png"),
        },
        { name: "vue", icon: require("../assets/icon/vue.png") },
        {
          name: "react",

          icon: require("../assets/icon/react.png"),
        },
        {
          name: "typescript",

          icon: require("../assets/icon/typescript.png"),
        },
        {
          name: "postgresql",

          icon: require("../assets/icon/postgresql.png"),
        },
        {
          name: "sql",

          icon: require("../assets/icon/mysql.png"),
        },

        // {
        //   name: "laravel",
        //   ability: 30,
        //   icon: require("../assets/icon/laravel.png"),
        // },
        // {
        //   name: "python",
        //   ability: 30,
        //   icon: require("../assets/icon/python.png"),
        // },
        // {
        //   name: "django",
        //   ability: 30,
        //   icon: require("../assets/icon/django.png"),
        // },
        {
          name: "swift",

          icon: require("../assets/icon/swift.png"),
        },

        {
          name: "illustrator",

          icon: require("../assets/icon/illustrator.png"),
        },
        {
          name: "photoshop",

          icon: require("../assets/icon/photoshop.png"),
        },
        { name: "php", icon: require("../assets/icon/php.png") },
        { name: "ruby", icon: require("../assets/icon/ruby.png") },
        { name: "aws", icon: require("../assets/icon/aws.png") },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.second {
  background-image: linear-gradient(to bottom, #fff 95%, #1f0d14 99%);
  padding-bottom: 3rem;
}

.container {
  max-width: 1280px;
  margin: 5rem auto 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .wrap {
    background-image: linear-gradient(
      to top,
      #fff 50%,
      #2f9e44 50%,
      #2f9e44 75%,
      #fff 75%
    );

    h3 {
      border-bottom: 3px solid #1f0d14;
      padding: 0 1.5rem;
      margin: 3rem 9rem;
      font-family: "Noto Serif JP", serif;
      font-size: 3rem;
      color: #1f0d14;
      filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
    }
  }

  .skills {
    margin: 1.5rem 2rem 0;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 3rem;
    align-items: center;
    justify-items: center;
  }
}

.html,
.css,
.javascript,
.sql {
  width: 100px;
}

.php,
.java,
.wordpress,
.django {
  width: 90px;
}

.sass,
.bootstrap,
.vue,
.react,
.typescript,
.postgresql,
.laravel,
.aws {
  width: 75px;
}

.python,
.swift,
.illustrator,
.photoshop {
  width: 65px;
}

.ruby {
  width: 55px;
}

// .typescript,
// .sql,
// .php,
// .python,
// .laravel,
// .django {
//   filter: grayscale(90%);
// }

.skill:hover {
  animation: jump 7s linear;
}

.html:hover {
  & ~ .css,
  ~ .javascript {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.css:hover {
  & ~ .sass,
  ~ .bootstrap {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.javascript:hover {
  & ~ .vue,
  ~ .react,
  ~ .typescript {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.wordpress:hover {
  & ~ .sql,
  ~ .php {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.java:hover {
  & ~ .postgresql {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.postgresql:hover {
  & ~ .sql {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.sql:hover {
  & ~ .php {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.php:hover {
  & ~ .laravel {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.python:hover {
  & ~ .django {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

.illustrator:hover {
  & ~ .photoshop {
    transition: all 1s ease-in;
    scale: 0.75;
    animation: jump 7s linear 1s;
  }
}

img {
  width: 100%;
  filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
}

@keyframes jump {
  10% {
    transform: rotate(5deg);
  }

  20% {
    transform: translateX(10%) translateY(-5%);
  }

  30% {
    scale: 1.1;
    transform: rotate(3deg);
  }

  40% {
    transform: translateX(-10%) translateY(-7%);
  }

  50% {
    scale: 1.05;
    transform: rotate(-5deg);
  }

  60% {
    transform: translateX(10%) translateY(-7%);
  }

  70% {
    scale: 1.1;
    transform: rotate(-10deg);
  }

  80% {
    transform: translateX(-10%) translateY(-5%);
  }

  90% {
    transform: translateY(-5%);
  }

  100% {
    transform: translateX(0) translateY(0);
  }
}

@media screen and (max-width: 750px) {
  .container {
    align-items: center;
    margin: 0 auto;
    scale: 0.85;

    .skills {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media screen and (max-width: 630px) {
  .container {
    .wrap {
      h3 {
        scale: 0.75;
        padding: 0 0.5rem;
        margin: 2.5rem 5rem;
      }
    }
  }
} ;
</style>
